import type { Drama } from '@/types/drama';

export const dramas: Drama[] = [
  {
    id: "1",
    title: "长夜将明",
    poster: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20TV%20drama%20poster%2C%20lone%20detective%20silhouette%20under%20cold%20night%20rain%20on%20a%20quiet%20city%20street%2C%20high%20contrast%20moody%20lighting%2C%20deep%20charcoal%20background%20with%20warm%20amber%20accents%2C%20minimalist%20vertical%20composition%2C%20soft%20film%20grain%2C%20no%20text&width=400&height=600&seq=drama-poster-01&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Cinematic%20night%20city%20skyline%20in%20the%20rain%2C%20reflective%20wet%20asphalt%20streets%2C%20moody%20teal%20and%20amber%20lighting%2C%20atmospheric%20fog%2C%20dramatic%20wide%20composition%20with%20deep%20dark%20tones%20and%20open%20space%20for%20text%20overlay%2C%20no%20text&width=1600&height=900&seq=drama-hero-01&orientation=landscape",
    featured: true,
    genres: ["悬疑", "犯罪"],
    region: "中国大陆",
    year: 2025,
    actors: ["张译", "王凯", "李沁"],
    director: "陈默",
    episodes: 32,
    latestEpisode: 32,
    updateTime: "2026-10-11",
    rating: 8.9,
    hot: 98,
    tags: ["刑侦", "烧脑", "年度口碑"],
    synopsis: "一桩尘封十二年的旧案在新城区再度浮现，刑警队长林昭与法医苏青并肩追查，却发现真相层层嵌套。随着每一个证人的离去，长夜之下，正义与私欲的边界逐渐模糊。",
  },
  {
    id: "2",
    title: "山河故梦",
    poster: "https://readdy.ai/api/search-image?query=Elegant%20ancient%20Chinese%20palace%20drama%20poster%2C%20flowing%20silk%20robes%20in%20deep%20crimson%20and%20gold%2C%20traditional%20ink%20wash%20mountains%20in%20background%2C%20soft%20lantern%20glow%2C%20refined%20minimalist%20vertical%20composition%2C%20rich%20warm%20tones%2C%20no%20text&width=400&height=600&seq=drama-poster-02&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20landscape%20with%20misty%20mountains%20and%20a%20grand%20traditional%20palace%20at%20dusk%2C%20warm%20golden%20lantern%20light%2C%20ink-wash%20painting%20atmosphere%2C%20deep%20crimson%20and%20amber%20accents%2C%20wide%20cinematic%20composition%20with%20open%20space%20for%20text%2C%20no%20text&width=1600&height=900&seq=drama-hero-02&orientation=landscape",
    featured: true,
    genres: ["古装", "剧情"],
    region: "中国大陆",
    year: 2025,
    actors: ["赵丽颖", "朱一龙"],
    director: "李木戈",
    episodes: 40,
    latestEpisode: 40,
    updateTime: "2026-10-10",
    rating: 8.7,
    hot: 95,
    tags: ["权谋", "虐恋", "大制作"],
    synopsis: "乱世之中，将门之女沈知微以一纸和亲踏入宫廷漩涡，与看似温润实则深藏锋芒的王爷周旋。山河依旧，故人成梦，她要在谋算与真心之间走出自己的路。",
  },
  {
    id: "3",
    title: "都市浮生记",
    poster: "https://readdy.ai/api/search-image?query=Modern%20urban%20life%20drama%20poster%2C%20skyscraper%20windows%20at%20golden%20hour%20reflecting%20a%20lone%20figure%2C%20warm%20orange%20and%20grey%20palette%2C%20clean%20minimalist%20vertical%20composition%2C%20soft%20realistic%20light%2C%20no%20text&width=400&height=600&seq=drama-poster-03&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Modern%20city%20skyline%20at%20golden%20sunset%2C%20glass%20office%20towers%20and%20busy%20streets%2C%20warm%20orange%20and%20soft%20grey%20tones%2C%20cinematic%20wide%20composition%20with%20clean%20open%20space%20for%20text%20overlay%2C%20no%20text&width=1600&height=900&seq=drama-hero-03&orientation=landscape",
    featured: true,
    genres: ["都市", "家庭"],
    region: "中国大陆",
    year: 2026,
    actors: ["雷佳音", "殷桃"],
    director: "刘海波",
    episodes: 36,
    latestEpisode: 28,
    updateTime: "2026-10-12",
    rating: 8.2,
    hot: 92,
    tags: ["现实题材", "口碑", "热播中"],
    synopsis: "中年失业的出版编辑周建平，在生活的重压下重新寻找自己的位置。一间小小的面馆，几个萍水相逢的陌生人，拼凑出都市里最真实的浮生百态。",
  },
  {
    id: "4",
    title: "星辰以南",
    poster: "https://readdy.ai/api/search-image?query=Science%20fiction%20space%20drama%20poster%2C%20astronaut%20helmet%20reflecting%20a%20distant%20galaxy%2C%20deep%20indigo%20with%20warm%20orange%20nebula%20glow%2C%20clean%20minimalist%20vertical%20composition%2C%20cinematic%20soft%20lighting%2C%20no%20text&width=400&height=600&seq=drama-poster-04&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Deep%20space%20nebula%20with%20warm%20orange%20and%20amber%20glow%20against%20dark%20cosmos%2C%20distant%20planet%20and%20starfield%2C%20cinematic%20wide%20composition%20with%20open%20space%20for%20text%20overlay%2C%20epic%20and%20calm%2C%20no%20text&width=1600&height=900&seq=drama-hero-04&orientation=landscape",
    featured: true,
    genres: ["科幻", "爱情"],
    region: "中国大陆",
    year: 2025,
    actors: ["杨幂", "陈飞宇"],
    director: "滕华涛",
    episodes: 30,
    latestEpisode: 30,
    updateTime: "2026-09-28",
    rating: 8.5,
    hot: 90,
    tags: ["科幻爱情", "星空", "完结"],
    synopsis: "近未来，地球资源枯竭，宇航员顾南受命远航寻找新家园。跨越光年的通讯延迟里，他与地球上的她以一段段延迟的留言维系着彼此。星辰以南，是思念的方向。",
  },
  {
    id: "5",
    title: "江湖不夜天",
    poster: "https://readdy.ai/api/search-image?query=Wuxia%20martial%20arts%20drama%20poster%2C%20swordsman%20silhouette%20under%20lantern-lit%20ancient%20bridge%2C%20falling%20petals%2C%20deep%20red%20and%20ink%20black%20palette%2C%20dynamic%20minimalist%20vertical%20composition%2C%20soft%20glow%2C%20no%20text&width=400&height=600&seq=drama-poster-05&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20night%20market%20with%20hundreds%20of%20red%20lanterns%2C%20misty%20river%20and%20wooden%20bridge%2C%20warm%20amber%20glow%20against%20dark%20blue%20night%2C%20cinematic%20wide%20composition%20with%20open%20space%20for%20text%2C%20no%20text&width=1600&height=900&seq=drama-hero-05&orientation=landscape",
    featured: true,
    genres: ["武侠", "古装"],
    region: "中国大陆",
    year: 2024,
    actors: ["肖战", "周也"],
    director: "曹盾",
    episodes: 45,
    latestEpisode: 45,
    updateTime: "2026-08-15",
    rating: 8.3,
    hot: 88,
    tags: ["武侠", "江湖", "完结"],
    synopsis: "江湖传言，得「不夜令」者可号令群雄。少年剑客萧白为查师父死因踏入江湖，在一场场快意恩仇中，逐渐看清所谓正义背后的算计。",
  },
  {
    id: "6",
    title: "暗涌",
    poster: "https://readdy.ai/api/search-image?query=Crime%20thriller%20drama%20poster%2C%20menacing%20harbor%20at%20night%20with%20reflections%2C%20cold%20grey%20and%20amber%20tones%2C%20tense%20minimalist%20vertical%20composition%2C%20soft%20film%20grain%2C%20no%20text&width=400&height=600&seq=drama-poster-06&orientation=portrait",
    genres: ["犯罪", "悬疑"],
    region: "中国香港",
    year: 2025,
    actors: ["古天乐", "刘青云"],
    director: "杜琪峰",
    episodes: 24,
    latestEpisode: 24,
    updateTime: "2026-10-05",
    rating: 8.6,
    hot: 86,
    tags: ["港剧", "警匪", "完结"],
    synopsis: "一场看似普通的走私案，牵出盘踞多年的地下网络。卧底警员在身份与良知之间如履薄冰，暗涌之下，谁又能全身而退。",
  },
  {
    id: "7",
    title: "春风十里外",
    poster: "https://readdy.ai/api/search-image?query=Romantic%20urban%20drama%20poster%2C%20young%20couple%20silhouette%20under%20blossoming%20trees%2C%20warm%20peach%20and%20cream%20tones%2C%20airy%20minimalist%20vertical%20composition%2C%20soft%20sunlit%20glow%2C%20no%20text&width=400&height=600&seq=drama-poster-07&orientation=portrait",
    genres: ["爱情", "都市"],
    region: "中国大陆",
    year: 2026,
    actors: ["虞书欣", "王安宇"],
    director: "张彤",
    episodes: 28,
    latestEpisode: 20,
    updateTime: "2026-10-09",
    rating: 7.9,
    hot: 84,
    tags: ["甜宠", "治愈", "热播中"],
    synopsis: "花店女孩温晚与冷淡的建筑师陆时衍因一场误会相识。春风十里，不及你一句晚来的晚安。两人在琐碎日常里慢慢靠近。",
  },
  {
    id: "8",
    title: "拾光者",
    poster: "https://readdy.ai/api/search-image?query=Science%20fiction%20drama%20poster%2C%20retro%20vintage%20camera%20and%20glowing%20light%20beams%2C%20warm%20sepia%20and%20teal%20palette%2C%20clean%20minimalist%20vertical%20composition%2C%20soft%20cinematic%20light%2C%20no%20text&width=400&height=600&seq=drama-poster-08&orientation=portrait",
    genres: ["科幻", "剧情"],
    region: "美国",
    year: 2025,
    actors: ["Emily Stone", "David Chen"],
    director: "Nolan Reed",
    episodes: 12,
    latestEpisode: 12,
    updateTime: "2026-09-20",
    rating: 9.1,
    hot: 89,
    tags: ["美剧", "时间", "神作"],
    synopsis: "一名能短暂回溯时光的修复师，为了挽回至亲的遗憾一次次修改过去，却发现每一次改变都在撕裂当下。拾起的光，终究要付出代价。",
  },
  {
    id: "9",
    title: "归途有风",
    poster: "https://readdy.ai/api/search-image?query=Warm%20family%20drama%20poster%2C%20countryside%20road%20at%20dusk%20with%20a%20small%20car%2C%20golden%20fields%20and%20soft%20sky%2C%20warm%20amber%20and%20green%20tones%2C%20calm%20minimalist%20vertical%20composition%2C%20no%20text&width=400&height=600&seq=drama-poster-09&orientation=portrait",
    genres: ["家庭", "剧情"],
    region: "中国大陆",
    year: 2024,
    actors: ["海清", "黄渤"],
    director: "汪俊",
    episodes: 34,
    latestEpisode: 34,
    updateTime: "2026-07-30",
    rating: 8.4,
    hot: 80,
    tags: ["家庭", "治愈", "完结"],
    synopsis: "在外打拼多年的女儿回到故乡小城，面对年迈的父母与早已陌生的街巷。归途有风，吹散偏见，也吹回了久违的团圆。",
  },
  {
    id: "10",
    title: "雪落无声",
    poster: "https://readdy.ai/api/search-image?query=Korean%20mystery%20drama%20poster%2C%20lone%20figure%20in%20a%20snowy%20forest%20at%20blue%20hour%2C%20cold%20white%20and%20soft%20amber%20accents%2C%20quiet%20minimalist%20vertical%20composition%2C%20soft%20grain%2C%20no%20text&width=400&height=600&seq=drama-poster-10&orientation=portrait",
    genres: ["悬疑", "剧情"],
    region: "韩国",
    year: 2025,
    actors: ["李敏镐", "金高银"],
    director: "朴赞郁",
    episodes: 16,
    latestEpisode: 16,
    updateTime: "2026-10-01",
    rating: 8.8,
    hot: 85,
    tags: ["韩剧", "悬疑", "完结"],
    synopsis: "一个偏远小镇，一场持续七天的暴雪，一桩无人报案的失踪。记者与当地警官在寂静的雪原里，一步步逼近被掩埋的真相。",
  },
  {
    id: "11",
    title: "梨园旧事",
    poster: "https://readdy.ai/api/search-image?query=Period%20drama%20poster%2C%20traditional%20Chinese%20opera%20stage%20with%20red%20curtains%20and%20warm%20spotlight%2C%20rich%20crimson%20and%20gold%20tones%2C%20elegant%20minimalist%20vertical%20composition%2C%20no%20text&width=400&height=600&seq=drama-poster-11&orientation=portrait",
    genres: ["古装", "年代"],
    region: "中国大陆",
    year: 2024,
    actors: ["秦岚", "张若昀"],
    director: "孔笙",
    episodes: 42,
    latestEpisode: 42,
    updateTime: "2026-06-18",
    rating: 8.1,
    hot: 75,
    tags: ["年代", "戏曲", "完结"],
    synopsis: "民国梨园，一代名伶在繁华与动荡之间沉浮。戏台上唱尽悲欢，戏台下的人生却比戏文更难收场。",
  },
  {
    id: "12",
    title: "半糖时光",
    poster: "https://readdy.ai/api/search-image?query=Light%20romantic%20comedy%20poster%2C%20cafe%20table%20with%20two%20cups%20and%20warm%20sunlight%2C%20soft%20cream%20and%20peach%20palette%2C%20playful%20minimalist%20vertical%20composition%2C%20no%20text&width=400&height=600&seq=drama-poster-12&orientation=portrait",
    genres: ["爱情", "喜剧"],
    region: "中国台湾",
    year: 2026,
    actors: ["许光汉", "林心如"],
    director: "陈玉珊",
    episodes: 20,
    latestEpisode: 14,
    updateTime: "2026-10-08",
    rating: 7.7,
    hot: 72,
    tags: ["台剧", "甜剧", "热播中"],
    synopsis: "一家只做半糖甜度的咖啡馆，两个对感情都小心翼翼的人。半糖，是刚好能尝到甜，又不至于腻味的距离。",
  },
  {
    id: "13",
    title: "烽火连城",
    poster: "https://readdy.ai/api/search-image?query=War%20epic%20drama%20poster%2C%20rugged%20soldier%20silhouette%20before%20glowing%20distant%20fortress%2C%20deep%20amber%20and%20charcoal%20tones%2C%20dramatic%20minimalist%20vertical%20composition%2C%20soft%20smoke%2C%20no%20text&width=400&height=600&seq=drama-poster-13&orientation=portrait",
    genres: ["战争", "历史"],
    region: "中国大陆",
    year: 2025,
    actors: ["段奕宏", "张丰毅"],
    director: "康洪雷",
    episodes: 38,
    latestEpisode: 38,
    updateTime: "2026-05-12",
    rating: 8.6,
    hot: 78,
    tags: ["战争", "史诗", "完结"],
    synopsis: "一群被历史遗忘的守城将士，用血肉之躯挡下敌军最后的攻势。烽火连城，守的不只是一座城，更是一份信念。",
  },
  {
    id: "14",
    title: "快乐星球计划",
    poster: "https://readdy.ai/api/search-image?query=Playful%20sci-fi%20comedy%20poster%2C%20colorful%20retro%20spaceship%20and%20glowing%20planet%2C%20vivid%20orange%20and%20warm%20yellow%20palette%2C%20fun%20minimalist%20vertical%20composition%2C%20no%20text&width=400&height=600&seq=drama-poster-14&orientation=portrait",
    genres: ["喜剧", "科幻"],
    region: "中国大陆",
    year: 2026,
    actors: ["沈腾", "马丽"],
    director: "闫非",
    episodes: 24,
    latestEpisode: 18,
    updateTime: "2026-10-07",
    rating: 8.0,
    hot: 83,
    tags: ["喜剧", "爆笑", "热播中"],
    synopsis: "一支不靠谱的民间航天小队，误打误撞接下「快乐星球计划」。荒诞的发射倒计时里，一群普通人做起了最不普通的事。",
  },
  {
    id: "15",
    title: "潮汐之间",
    poster: "https://readdy.ai/api/search-image?query=Coastal%20romance%20drama%20poster%2C%20lighthouse%20on%20rocky%20shore%20at%20sunset%2C%20warm%20coral%20and%20muted%20grey%20tones%2C%20serene%20minimalist%20vertical%20composition%2C%20soft%20light%2C%20no%20text&width=400&height=600&seq=drama-poster-15&orientation=portrait",
    genres: ["都市", "爱情"],
    region: "中国大陆",
    year: 2025,
    actors: ["倪妮", "黄轩"],
    director: "黎志",
    episodes: 32,
    latestEpisode: 32,
    updateTime: "2026-09-15",
    rating: 8.2,
    hot: 76,
    tags: ["都市", "疗愈", "完结"],
    synopsis: "海岛灯塔看守与失意摄影师在潮汐涨落间相遇。有些人注定只是过客，有些人却像潮水，退了还会再来。",
  },
  {
    id: "16",
    title: "迷雾海岸",
    poster: "https://readdy.ai/api/search-image?query=British%20mystery%20drama%20poster%2C%20foggy%20cliff%20coast%20with%20small%20house%2C%20cold%20grey%20and%20deep%20amber%20accents%2C%20tense%20minimalist%20vertical%20composition%2C%20soft%20grain%2C%20no%20text&width=400&height=600&seq=drama-poster-16&orientation=portrait",
    genres: ["悬疑", "犯罪"],
    region: "英国",
    year: 2025,
    actors: ["Tom Hardy", "Olivia Colman"],
    director: "Sam Wright",
    episodes: 8,
    latestEpisode: 8,
    updateTime: "2026-09-30",
    rating: 8.9,
    hot: 81,
    tags: ["英剧", "推理", "完结"],
    synopsis: "海雾弥漫的小镇，每隔数年就会有人神秘失踪。退休警探与年轻记者联手，在层层伪装中揭开一段被刻意遗忘的往事。",
  },
  {
    id: "17",
    title: "繁花落尽",
    poster: "https://readdy.ai/api/search-image?query=Vintage%20period%20drama%20poster%2C%20lantern-lit%20old%20city%20alley%2C%20nostalgic%20warm%20sepia%20and%20crimson%20tones%2C%20refined%20minimalist%20vertical%20composition%2C%20soft%20light%2C%20no%20text&width=400&height=600&seq=drama-poster-17&orientation=portrait",
    genres: ["年代", "爱情"],
    region: "中国大陆",
    year: 2024,
    actors: ["胡歌", "唐嫣"],
    director: "王家卫",
    episodes: 40,
    latestEpisode: 40,
    updateTime: "2026-04-22",
    rating: 8.5,
    hot: 74,
    tags: ["年代", "上海", "完结"],
    synopsis: "上世纪九十年代的上海，霓虹与市井交织。几个年轻人在时代浪潮里追逐梦想，也错过了彼此最好的年华。繁花落尽，人未散。",
  },
  {
    id: "18",
    title: "我们的时辰",
    poster: "https://readdy.ai/api/search-image?query=Emotional%20urban%20drama%20poster%2C%20empty%20hospital%20corridor%20with%20warm%20dawn%20light%2C%20soft%20peach%20and%20grey%20tones%2C%20quiet%20minimalist%20vertical%20composition%2C%20no%20text&width=400&height=600&seq=drama-poster-18&orientation=portrait",
    genres: ["都市", "剧情"],
    region: "中国大陆",
    year: 2026,
    actors: ["袁泉", "张译"],
    director: "沈严",
    episodes: 30,
    latestEpisode: 22,
    updateTime: "2026-10-11",
    rating: 8.3,
    hot: 87,
    tags: ["医疗", "现实", "热播中"],
    synopsis: "深夜急诊科里，医生与家属都在和时间赛跑。每一个被抢救回来的时辰，都是平凡人拼尽全力守住的希望。",
  },
];

export const genres: string[] = ["都市", "古装", "悬疑", "爱情", "科幻", "家庭", "犯罪", "年代", "武侠", "喜剧", "战争", "历史"];

export const regions: string[] = ["中国大陆", "中国香港", "中国台湾", "韩国", "日本", "美国", "英国"];

export const years: number[] = [2026, 2025, 2024];